import React, { useState, useEffect } from "react"

//Styles
import "./OutputContainer.scss"


//External Components
import Button from '@material-ui/core/Button';

//Components
import OutputSwitch from './OutputSwitch'
import OutputTabs from './OutputTabs'
import OutputTable from './OutputTable'
import OutputRegion from './OutputRegion'
import ScenarioList from '../application/ScenarioList'
import ModalDialog from '../application/ModalDialog'


//Data
import output from '../../data/output.json'

function OutputContainer({model}) {

  const [outputView, setOutputView] = useState(0)
  const [outputTable, setOutputTable] = useState(1)
  const [outputRegion, setOutputRegion] = useState(1)
  const [modal, setModal] = useState({display: false, type: null})
  const [scenarios, setScenarios] = useState([])
  const [currentScenario, setCurrentScenario] = useState()
  const [refresh, setRefresh] = useState(true)

  useEffect(() => {
    
    if (refresh) {

      Window.initScenarios(model)
      
      if (Window.listScenarios(model).length === 0) {
        Window.saveScenario("Default Scenario", model)
        setCurrentScenario("Default Scenario")
      }

      let items = Window.listScenarios(model)
      setScenarios(items)
      setCurrentScenario(items[items.length - 1])

      Window.loadScenario(items[items.length - 1], model)
      setRefresh(false)
    }

  },[refresh])

  return (
    <div className={modal.display ? 'OutputContainer fixed' : 'OutputContainer' }>
      <div className="OutputTop">
        <div className="OutputBar">
          <OutputSwitch getView={(view) => {setOutputView(view)}} />
          <div className="OutputBarLeftActions">
            {/* <button className="LeftAction">Scenarios</button> */}
            <ScenarioList model={model} scenarios={scenarios} currentScenario={currentScenario} setCurrentScenario={setCurrentScenario} />
            <Button variant="contained" onClick={() => setModal({display: true, type: 'edit'})}>Edit Scenario</Button>
            <Button variant="contained" onClick={() => setModal({display: true, type: 'create'})}>Create Scenario</Button>
          </div>
        </div>
        <OutputTabs classNameProp={outputView === 0 ? '' : 'hidden'} tabs={output[0].items[model !== "Charter" ? 0 : 2 ].tabs} getTab={(id) => {setOutputTable(id)}} />
        <OutputTabs classNameProp={outputView === 1 ? '' : 'hidden'} tabs={output[1].tabs} getTab={(id) => {setOutputRegion(id)}} />
      </div> 

      <div className={`OutputContent ${outputView === 1 ? 'hidden' : ''}`}>
        {output[2].items.map(item => (
          <OutputTable key={item.id}
          className={outputTable === item.id ? `OutputTable_${model}` : 'Output_hidden'}
          title={item.id - 1}
          table={item.table}
          precision={false}
          report_type={item.report_type}
          model={model}/>
        ))}

        {output[2].items.map(item => (
          <OutputTable key={item.id}
          id={item.id}
          className="Output_hidden"
          title={item.id - 1}
          table={item.table}
          precision={true}
          report_type={item.report_type}
          model={model}/>
        ))}
      </div>
      <div className={`OutputContent ${outputView === 0 ? 'hidden' : ''}`}>
        {output[3].items.map(item => (
          <OutputRegion key={item.id}
          className={outputRegion === item.id ? `OutputRegion_${model}` : 'Output_hidden'}
          model={model}
          title={item.fullName}
          precision={false}
          region={item.region} />
        ))}

        {output[3].items.map(item => (
          <OutputRegion key={item.id}
          className="Output_hidden"
          model={model}
          title={item.fullName}
          precision={true}
          region={item.region} />
        ))}
      </div>
    
      <ModalDialog model={model} 
        type={modal.type}
        trigger={modal.display}
        setTrigger={setModal}
        setRefresh={setRefresh}
        currentScenario={currentScenario}
        setCurrentScenario={setCurrentScenario} />

    </div>
  )

}

export default OutputContainer